import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'deviceManagementExperience.list'

const DeviceManagementDeviceListSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default DeviceManagementDeviceListSlice
